// Translator authorization for translation orders (TUL-5330).
//
// The available levels (Authorized/Unauthorized, TUL-4823) come from the
// backend in the user payload as user.translationLevels [{ id, name }] —
// names already localized — and the customer's selection is held as an array
// of level ids. A translation prebooking's level_id gates which translators
// receive offers; null means no authorization requirement.

// Maps the selection to the prebooking levelId: exactly one level selected ->
// that level; anything else (all levels, empty, or missing) -> null. With more
// than two levels a partial multi-selection cannot be represented in the
// single level_id column and also falls back to "no requirement".
export const getTranslationOrderLevelId = (selectedLevelIds) => {
  const ids = Array.isArray(selectedLevelIds) ? selectedLevelIds : [];
  return ids.length === 1 ? ids[0] : null;
};
